/**
 * The finally() method returns a Promise.
 * IE Support
 *
 */
export function Finally() {
  (function() {
    // Polyfill for Promise.prototype.finally
    // Get a handle on the global object
    let globalObject;
    if (typeof global !== "undefined") {
      globalObject = global;
    } else if (typeof window !== "undefined" && window.document) {
      globalObject = window;
    }

    // check if the implementation is available
    if (typeof Promise.prototype["finally"] === "function") {
      return;
    }

    // implementation
    globalObject.Promise.prototype["finally"] = function(callback) {
      const constructor = this.constructor;

      return this.then(
        function(value) {
          return constructor.resolve(callback()).then(function() {
            return value;
          });
        },
        function(reason) {
          return constructor.resolve(callback()).then(function() {
            throw reason;
          });
        }
      );
    };
  })();
}

/**
 * The closest() method traverses the Element and its parents
 *  IE support
 *
 */
export function Closest() {
  // Closest Polyfill
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  }

  if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
      var el = this;

      do {
        if (el.matches(s)) return el;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    };
  }
}
